import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["chevron", "details"]

  toggle(event) {
    event.preventDefault();
    this.detailsTarget.style.display = this.detailsTarget.style.display === "none" ? "table-row" : "none";
    this.chevronTarget.classList.toggle("fa-chevron-down");
    this.chevronTarget.classList.toggle("fa-chevron-up");
  }
}
